'use strict';

$(document).ready(function () {
    const device = $('.faq-page').attr('device');

    if (device !== 'mobile') {
        let $firstTab = $('.faq-tab').first().addClass('active-btn');
        let firstTabID = $firstTab.attr('tab-id');

        let $firstFaqContents = $(`.faq-content[content-id='${firstTabID}']`);
        $firstFaqContents.addClass('active');
    } else {
        let currentTabID = $('.change-content-mobile').val();
        let $selectedFaqContents = $(`.faq-content[content-id='${currentTabID}']`);
        $selectedFaqContents.addClass('active');
    }

    $('.faq-tab').click(function (e) {
        e.preventDefault();

        const $faqTabs = $('.faq-tab');
        $faqTabs.removeClass('active-btn');

        let $currentTab = $(this);
        $currentTab.addClass('active-btn');

        const $faqContents = $('.faq-content');
        $faqContents.removeClass('active');

        let currentTabID = $currentTab.attr('tab-id');

        let $selectedFaqContents = $(`.faq-content[content-id='${currentTabID}']`);
        $selectedFaqContents.addClass('active');
    });

    $('.change-content-mobile').on('change', function () {
        let currentTabID = $('.change-content-mobile').val();
        const $faqContents = $('.faq-content');
        $faqContents.removeClass('active');

        let $selectedFaqContents = $(`.faq-content[content-id='${currentTabID}']`);
        $selectedFaqContents.addClass('active');
    });
});
